import { render, staticRenderFns } from "./_ExpandTransition.vue?vue&type=template&id=183984b0&"
import script from "./_ExpandTransition.vue?vue&type=script&lang=js&"
export * from "./_ExpandTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports